import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { projectsMenuEvents } from 'app/modules/wallforming/components/projects-manager/types/projectsMenuEvents';

export const LoadProject = () => {
    const { t } = useTranslation();

    return (
        <Menu.Item
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="folder_open" />
            }
            rightSection={<ActionShortcutHint actionId={InputActionId.GeneralOpenProjects} />}
            onClick={() => window.dispatchEvent(new Event(projectsMenuEvents.openLoad))}
        >
            {t('labelLoadProject')}
        </Menu.Item>
    );
};
